import styled from "styled-components";
import { darkBlue, zeeguuOrange } from "./colors";

// Source: https://loading.io/css/

const LoadingContainer = styled.div`
  margin: 2.5em;
  text-align: center;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: 80%;
  flex-direction: column;
`;

const LoadingAnimation = styled.div`
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .student div {
    background: ${zeeguuOrange};
  }

  .teacher div {
    background: ${darkBlue};
  }

  /* Muted heartbeat above the wait-drill — reads as background motion,
     not a primary loader. */
  .muted div {
    background: #cfcfcf;
  }
  :root[data-theme="dark"] & .muted div {
    background: #555;
  }
  .lds-ellipsis.muted div {
    animation-duration: 1.5s;
  }

  .lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;

    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`;

export { LoadingAnimation, LoadingContainer };
